import { render, staticRenderFns } from "./SafetyReportViewer.vue?vue&type=template&id=7181066f&scoped=true&"
import script from "./SafetyReportViewer.vue?vue&type=script&lang=js&"
export * from "./SafetyReportViewer.vue?vue&type=script&lang=js&"
import style0 from "./SafetyReportViewer.vue?vue&type=style&index=0&id=7181066f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181066f",
  null
  
)

export default component.exports